"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_MAGAZINE_CARD = exports.DATA_TOPICS_DETAIL_MAGAZINES_BUTTON = exports.DATA_TOPICS_DETAIL_MAGAZINES = exports.DATA_TOPICS_BUTTON = exports.DATA_TOPICS_LIST = exports.DATA_TOPICS = void 0;
// Topics
exports.DATA_TOPICS = 'data-topics';
exports.DATA_TOPICS_LIST = 'data-topics-list';
exports.DATA_TOPICS_BUTTON = 'data-topics-button';
// Topics Detail
exports.DATA_TOPICS_DETAIL_MAGAZINES = 'data-topics-detail-magazines';
exports.DATA_TOPICS_DETAIL_MAGAZINES_BUTTON = 'data-topics-detail-magazines-button';
exports.DATA_MAGAZINE_CARD = 'data-magazine-card';
